import { CoreEffects } from '@app/core/store/core.effects';
import { UserEffects } from '@app/modules/users/store/effects/user.effects';
import { SettingsEffects } from '@app/modules/settings/store/effects/settings.effects';
import { OrganizationEffects } from '@app/modules/organization/store/effects/organization.effects';
import { CountsEffects } from '@app/modules/counts/store/effects/counts.effects';
import { ProductsEffects } from '@app/modules/products/store/effects/products.effects';
import { ImageEffects } from '@app/modules/image/store/effects/image.effects';
import { IntegrationsEffects } from '@app/modules/integrations/store/effects/integrations.effects';
import { QuickbooksEffects } from '@app/modules/quick-books/store/effects/quickbooks.effects';
import { RoleEffects } from '@app/modules/roles/store/effects/role.effects';
import { StoragesEffects } from '@app/modules/storages/store/effects/storages.effects';
import { PickingsEffects } from '@app/modules/pickings/store/effects/pickings.effects';
import { ReceivingsEffects } from '@app/modules/receivings/store/effects/receivings.effects';
import { PicklistsEffects } from '@app/modules/picklists/store/effects/picklists.effects';
import { ReportsEffects } from '@app/modules/reports/store/effects/reports.effects';

export const AppEffects: any[] = [
  CoreEffects,
  UserEffects,
  RoleEffects,
  SettingsEffects,
  OrganizationEffects,
  ProductsEffects,
  ReportsEffects,
  StoragesEffects,
  PickingsEffects,
  ReceivingsEffects,
  PicklistsEffects,
  CountsEffects,
  ImageEffects,
  IntegrationsEffects,
  QuickbooksEffects
];
